import { render, staticRenderFns } from "./proof-details.vue?vue&type=template&id=1551f2eb&scoped=true&"
import script from "./proof-details.vue?vue&type=script&lang=js&"
export * from "./proof-details.vue?vue&type=script&lang=js&"
import style0 from "./proof-details.vue?vue&type=style&index=0&id=1551f2eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1551f2eb",
  null
  
)

export default component.exports